import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useMultiBuildingMobileViewEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.MultiBuildingMobileView,
    false
  );

  return Boolean(isEnabled);
}
